import script from "./profile.vue?vue&type=script&setup=true&lang=js"
export * from "./profile.vue?vue&type=script&setup=true&lang=js"

import "./profile.vue?vue&type=style&index=0&id=77988e09&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77988e09"]])

export default __exports__